import type { FC, ReactElement } from 'react';
import React from 'react';

type AnchorableProps = {
  nodeId: string;
  children: ReactElement;
};

const Anchorable: FC<AnchorableProps> = ({ nodeId, children }) => {
  return React.cloneElement(React.Children.only(children), { id: `viewer-${nodeId}` });
};

export default Anchorable;
